import { API_URL, numberWithCommas } from '../../constant';
import React, {useEffect, useState} from 'react';
import { useLocalStorage } from "../../useLocalStorage";
import "./MemberCard.css";
import Barcode from 'react-barcode';
import Logo from "../../images/logo.png";
import MemberCardPNG from "../../images/member_card.png"


let MemberCard = (props)=>{
    const [token, setToken] = useLocalStorage("token", "");
    const [profile, setProfile] = useState("");

    function getProfile(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/profile`, requestOptions)
        .then(response => response.json())
        .catch(error => {});
    }
    
    useEffect(async ()=>{
        let response = await getProfile();
        if(response.status == 200){
            setProfile(response.data);
            console.log(response.data);
        }
    },[]);
    return (
        <div className='membercard-outer'>
            <div className='membercard-container'>
                <div className='membercard-card' style={{backgroundImage: `url(${MemberCardPNG})`, backgroundSize: `cover`}}>
                    <div className='membercard-top'>
                        <div className='membercard-logo'>
                            {/* <img src={Logo} width="150"/> */}
                        </div>
                        <div className='membercard-name'>
                            {/* {profile.Name} */}
                        </div>
                    </div>
                    <div className='membercard-bottom'>
                        <div className='membercard-name'>
                            {profile.Name}
                        </div>
                        <div className='membercard-name'>
                            {profile.UserName}
                        </div>
                        {/* <Barcode
                            value={profile.UserName}
                            width = "2"
                            height = "50"
                            background = "rgba(255,255,255,0.4)"
                        /> */}
                    </div>
            </div>
            </div>
            <div className="membercard-row">
                <Barcode
                    value={profile.UserName}
                    width = "2"
                    height = "50"
                    background = "rgba(255,255,255,0.4)"
                />
            </div>
        </div>
    );
}

export default MemberCard;